import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState } from "@miplatform/hooks";
import { ICommunitiesResponse } from "@miplatform/types";

export const useCommunities = () => {
  const [communities, setCommunities] = useState<ICommunitiesResponse[]>([]);

  const stateManager = useComponentState();

  const getCommunities = () => {
    return stateManager.run(async () => {
      const response = await homeService.communities.getAll({
        sort: "name",
      });
      if (response.status === HTTP_STATUSES.OK) {
        setCommunities(response.data);
      }
      return response;
    });
  };

  return {
    isLoading: stateManager.isBusy(),
    communities,
    getCommunities,
  };
};
